// extracted by mini-css-extract-plugin
export default {"circle-in":"CircularProgressWithLabel_circle-in__NnxAQ","box-content":"CircularProgressWithLabel_box-content__v3LCO"};